import { render, staticRenderFns } from "./ModalCompanyCampaign.vue?vue&type=template&id=72fa8e84"
import script from "./ModalCompanyCampaign.vue?vue&type=script&lang=js"
export * from "./ModalCompanyCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports